import { render, staticRenderFns } from "./question-basket.vue?vue&type=template&id=030f6a08&scoped=true"
import script from "./question-basket.vue?vue&type=script&lang=js"
export * from "./question-basket.vue?vue&type=script&lang=js"
import style0 from "./question-basket.vue?vue&type=style&index=0&id=030f6a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030f6a08",
  null
  
)

export default component.exports